import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Post, { postStatuses } from '../../components/projectPost/Post';
import { useActions } from '../../hooks/useActions';
import { useSelector } from '../../hooks/useSelector';
import _cloneDeep from 'lodash/cloneDeep';
import { format } from 'date-fns/esm';

import './ProjectPostPage.css';
import { postsPages } from '../../components/projectSubCategory/SubCategory';
import { ReactComponent as BackArrowIcon } from './back-arrow.svg';
import { useAuth } from '../../hooks/useAuth';
import AppLoader from '../../components/appLoader/AppLoader';
import * as ROUTES from './../../constants/routes';

const ProjectPostPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const {
        currentUser: { uid: userId, email },
        isAdmin,
    } = useAuth();

    const {
        data: postData,
        loading,
        subCategoryTitle,
        subCategories,
        page,
        isAccessDenied,
    } = useSelector(state => state.post);
    const { invitationsPostIds, publishedPostIds } = useSelector(state => state.notifications);
    const { fetchNewInvitationsPostCount, clearPostData } = useActions();

    const { fetchPost } = useActions();

    useEffect(() => {
        return () => {
            clearPostData();
        };
    }, []);

    useEffect(() => {
        if (userId) fetchPost({ id, userId, email, isAdmin });
    }, [id, userId, email]);

    useEffect(() => {
        if (!loading && postData !== null && isAccessDenied) {
            // debugger
            navigate(ROUTES.MY_ALL_POSTS);
        }
    }, [postData]);

    const handleBackToClick = useCallback(() => {
        fetchNewInvitationsPostCount({ email, uid: userId });
        navigate(`/posts/${page !== postsPages.published ? page.toLowerCase() : 'my'}`);
    }, [navigate, page]);

    return (
        <div className="post-page__wrap">
            {loading && (
                <div className="posts__title-container-outer">
                    <div className="height-full align-items-center d-flex justify-content-center posts__title">
                        <AppLoader />
                    </div>
                </div>
            )}
            {postData && !loading && !isAccessDenied && (
                <>
                    <div className="posts-top-space" />
                    <div className="post-page__content-wrap">
                        <div className="post-page__content-header">
                            <button
                                className="back-to-subcategories__button"
                                onClick={handleBackToClick}
                            >
                                <BackArrowIcon />
                                <span>{subCategoryTitle}</span>
                            </button>
                            <div className="post-page__content-title">
                                <span>/ {postData?.title || 'mock title'}</span>
                            </div>
                        </div>
                        <Post
                            key={postData.uid}
                            id={postData.uid}
                            viewsCount={postData.viewed.length}
                            reviewsCount={postData.responseEmails.length}
                            rawPost={_cloneDeep(postData)}
                            postStatus={postData?.status || null}
                            publisherUid={postData.publisherUid}
                            date={format(postData.createdTimestamp.toDate(), 'MMM dd, yyyy')}
                            title={postData.title}
                            description={postData.description}
                            budget={postData.budget}
                            category={postData.category}
                            briefLink={
                                postData.brief || postData.notion || postData.otherLink || ''
                            }
                            page={page}
                            subCategoryTitle={subCategoryTitle}
                            subCategories={subCategories}
                            invitationsPostIds={invitationsPostIds}
                            publishedPostIds={publishedPostIds}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default ProjectPostPage;
